import { render } from "./edit.vue?vue&type=template&id=370b7bb3&scoped=true"
import script from "./edit.vue?vue&type=script&setup=true&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&lang=js"

import "./edit.vue?vue&type=style&index=0&id=370b7bb3&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370b7bb3"],['__file',"resources/js/components/whatsapp-managment/includes/Profile/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "370b7bb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('370b7bb3', __exports__)) {
    console.log('reload')
    api.reload('370b7bb3', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=370b7bb3&scoped=true", () => {
    console.log('re-render')
    api.rerender('370b7bb3', render)
  })

}


export default __exports__